// convert object to query string
function toQueryString(obj) {
  if (obj) {
    return (
    '?' +
    Object.keys(obj)
      .filter(function(key) { return obj[key] !== undefined })
      .map(function(key) { return key + '=' + obj[key] })
      .join('&')
    );
  }
}

// format a Date object as DD-MM-YY
function formatDate(date) {
  const day = String(date.getDate());
  const month = String(date.getMonth() + 1);
  const year = String(date.getFullYear());

  return [month, day, year].join('-');
}

// convert YYYY-MM-DD HH:MM:SS String to Date object
function getDateFromString(str) {
  const parts = str.split(/-|:|\s/);
  parts[1]--; // decrement month to zero-index
  return new Date(...parts);
}

// convert <Event /> to Object with simplified properties
function attributesToObject(element) {
  const attributes = element.attributes;

  return {
    eventID: attributes['EventID'].value,
    title: attributes['Title'].value,
    start: getDateFromString(attributes['TimeStart'].value),
    end: getDateFromString(attributes['TimeEnd'].value),
    displayTime: attributes['Time'].value,
    url: attributes['URL'].value,
    imageUrl: process.env.REACT_APP_EVENT_IMAGE_LOCATION 
      + '?mediaId=' 
      + (attributes['ImageID'] ? attributes['ImageID'].value : '')
  };
}

// Promise wrapper for XMLHttpRequest
function retrieveXML(url) {
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();
    req.open('GET', url);
    req.onload = () => resolve(req.responseXML);
    req.onerror = () => reject('Could not fetch from ' + url);
    req.send();
  });
}

function getCalendar(id, startDate, endDate) {

  return new Promise((resolve, reject) => {
    const req = process.env.REACT_APP_API_LOCATION +
      toQueryString({
        seed: Date.now(),
        tzi: new Date().getTimezoneOffset(),
        startdate: '' + formatDate(startDate),
        enddate: '' + formatDate(endDate),
        calendarid: id
      });
      console.log(req);
      retrieveXML(req)
      .then(eventsDocument => {
        const events = Array.from(eventsDocument.getElementsByTagName('Event'));
        resolve(events.map(attributesToObject));
      })
      .catch(reject)
  });
}

// get the events for a specific date range
export function getEvents(startDate, endDate, noBackDate) {
  return new Promise((resolve, reject) => {

    if (!startDate && !endDate) {
      reject('Expected two dates. Got ' + startDate + ' and ' + endDate + '.');
    }

    const backDate = new Date(startDate);
    if (!noBackDate) {
      backDate.setDate(backDate.getDate() - 1);
    }

    // const events = getCalendar(1, backDate, endDate);
    // const featured = getCalendar(2, backDate, endDate);

    const events = getCalendar(1, startDate, endDate);
    const featured = getCalendar(2, startDate, endDate);

    Promise.all([events, featured])
    .then(([events, featured]) => {

      const featuredIds = featured.map(event => event.eventID);
      const now = Date.now();

      return events
        .filter(event => {
          // return events from the previous day that are still ongoing as well
          return (event.start.getDate() >= startDate.getDate())
          || (event.start <= now && event.end >= now && event.end.getDate() === startDate.getDate())
          || (now - event.end <= 14400000) // return events from the previous day that are less than 4 hours expired
        })
        .map(event => {
          if (featuredIds.includes(event.eventID)) {
            event.vwwOtd = true;
            return event;
          }
          return event;
        });
    })
    .then(resolve)
    .catch(reject);
  });
}

export function getFeaturedEvents(startDate, endDate) {
  return new Promise((resolve, reject) => {

    if (!startDate && !endDate) {
      reject('Expected two dates. Got ' + startDate + ' and ' + endDate + '.');
    }

    getCalendar(2, startDate, endDate)
    .then(resolve)
    .catch(reject);

  });
}
